export class HtmlBuilder {
	constructor(ids, classes, content) {
		this.ids = ids
		this.classes = classes
		this.content = content
	}

	build() {
		return `<wfs-google-maps
      id="${this.ids.id}"
      :zoom="${this.content.zoom}"
      :lat="${this.content.lat}"
      :lng="${this.content.lng}"
      mapType="${this.content.mapType}"
      :mapStyle='${JSON.stringify(this.content.mapStyle)}'
      :zoomControl="${this.content.zoomControl ?? false}"
      :scaleControl="${this.content.scaleControl ?? false}"
      :streetViewControl="${this.content.streetViewControl ?? false}"
      icon="${this.content.icon ?? ''}"
      :markers='${JSON.stringify(this.content.markers)}'
      classes="${this.classes.classes}"
    >
    </wfs-google-maps>`
	}
}